import React, {Component} from 'react';

class SidebarHeader extends Component {

  render() {
    return (
      <div className="sidebar-header">
        <img
          className="headerLogo" 
          src="img/logo-roundedtype.svg" width="225">
        </img>
      </div>
    )
  }
}

export default SidebarHeader;



// WEBPACK FOOTER //
// ./src/components/SidebarHeader/SidebarHeader.js